import React, { lazy, Suspense, useEffect } from "react";
import createSagaMiddleware from "redux-saga";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import { MUITheme } from "./utils/MUITheme";

import appSaga from "./sagas/app";
import rootReducer from "./reducers/app";

import { loadHotjar } from "./hotjar";

import LocationCheck from "./components/LocationCheck";
import initSentry from "./Sentry";

const sagaMiddleware = createSagaMiddleware();
const store = createStore(rootReducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(appSaga);

const AssessmentWelcome = lazy(() => import("./containers/AssessmentWelcome"));
const ChatboxPage = lazy(() => import("./containers/ChatboxPage"));
const Guidelines = lazy(() => import("./containers/Guidelines"));
const InvalidLink = lazy(() => import("./containers/InvalidLink"));
const SectionEnd = lazy(() => import("./containers/SectionEnd"));
const SignIn = lazy(() => import("./containers/SignIn"));
const Success = lazy(() => import("./containers/Success"));
const VideoChatboxPage = lazy(() => import("./containers/VideoChatboxPage"));
const SystemCheck = lazy(() => import("./containers/SystemCheck"));

const CustomRouter = () => {
    useEffect(() => {
        initSentry();
        loadHotjar();
    }, []);

    return (
        <Provider store={store}>
            <ThemeProvider theme={MUITheme}>
                <BrowserRouter>
                    <Suspense
                        fallback={
                            <div
                                style={{
                                    width: "100vw",
                                    height: "100vh",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                {" "}
                                Loading...
                            </div>
                        }
                    >
                        <Routes>
                            <Route
                                exact
                                path="/demorush/:workflowId"
                                element={<SignIn />}
                            />
                            <Route
                                exact
                                path="/dashboard/company"
                                element={<AssessmentWelcome />}
                            />
                            <Route
                                exact
                                path="/dashboard/:comp/:workflowId/:user_id"
                                element={<Guidelines />}
                            />
                            <Route
                                exact
                                path="/chatbox"
                                element={
                                    <LocationCheck>
                                        <ChatboxPage />
                                    </LocationCheck>
                                }
                            />
                            <Route
                                exact
                                path="/invalid"
                                element={<InvalidLink type="INVALID" />}
                            />
                            <Route
                                exact
                                path="/test-not-available"
                                element={<InvalidLink type="TESTNA" />}
                            />
                            <Route
                                exact
                                path="/expired"
                                element={<InvalidLink type="EXPIRED" />}
                            />
                            <Route
                                exact
                                path="/success"
                                element={<Success />}
                            />
                            <Route
                                exact
                                path="/trial-bot-guidelines/:user_id"
                                element={<Guidelines trialBot={true} />}
                            />
                            <Route
                                exact
                                path="/trial-bot"
                                element={<ChatboxPage trialBot={true} />}
                            />
                            <Route
                                exact
                                path="/section-end"
                                element={<SectionEnd />}
                            />
                            <Route
                                exact
                                path="/video/chatbox"
                                element={
                                    <LocationCheck>
                                        <VideoChatboxPage />
                                    </LocationCheck>
                                }
                            />
                            <Route
                                exact
                                path="/system-check"
                                element={<SystemCheck />}
                            />
                        </Routes>
                    </Suspense>
                </BrowserRouter>
            </ThemeProvider>
        </Provider>
    );
};

export default CustomRouter;
